(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-info-nutritional-facts"] && !Shopify.designMode) return;
  try {
    console.log("working javascript code");
    document.querySelectorAll('[data-slider-nutrition]').forEach((slider) => {
      console.log("slider", slider);
    const track = slider.querySelector('.slider-track');
    const slides = slider.querySelectorAll('.slider-slide');
    const prevBtn = slider.querySelector('[data-prev]');
    const nextBtn = slider.querySelector('[data-next]');

    let index = 0;

    function update() {
      track.style.transform = `translateX(-${index * 100}%)`;
      prevBtn.disabled = index === 0;
      nextBtn.disabled = index === slides.length - 1;
    }

    prevBtn.addEventListener('click', () => {
      if (index > 0) {
        index--;
        update();
      }
    });

    nextBtn.addEventListener('click', () => {
      console.log("next btn");
      if (index < slides.length - 1) {
        index++;
        update();
      }
    });

    update();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-info-whats-inside"] && !Shopify.designMode) return;
  try {
    console.log("working javascript code");
    document.querySelectorAll('[data-slider-inside]').forEach((slider) => {
      console.log("slider", slider);
    const track = slider.querySelector('.slider-track');
    const slides = slider.querySelectorAll('.slider-slide');
    const prevBtn = slider.querySelector('[data-prev]');
    const nextBtn = slider.querySelector('[data-next]');

    let index = 0;

    function update() {
      track.style.transform = `translateX(-${index * 100}%)`;
      prevBtn.disabled = index === 0;
      nextBtn.disabled = index === slides.length - 1;
    }

    prevBtn.addEventListener('click', () => {
      if (index > 0) {
        index--;
        update();
      }
    });

    nextBtn.addEventListener('click', () => {
      console.log("next btn");
      if (index < slides.length - 1) {
        index++;
        update();
      }
    });

    update();
  });
  } catch(e) { console.error(e); }
})();

})();
